import React, { useState, useEffect } from "react";
import Navbar from "components/Navbar";
import axios from "axios"

const apiUrl = process.env.REACT_APP_API_URL;

const UpdateEntitlement = () => {
  const [loading, setLoading] = useState(true);
  const [refetchDB, setRefetchDB] = useState(false)

  const [formData, setFormData] = useState({
    client_id: "",
    user_id: "",
    group_id: "",
    permissions: {
      view: false,
      upload: false,
      download: false,
      execute: false,
    },
  });

  const[clientData, setClientData] = useState(
    [
      {'client_id': 1, 'client_name': 'Client 1'},
      {'client_id': 2, 'client_name': 'Client 2'},
      {'client_id': 3, 'client_name': 'Client 3'}
    ]
  );

  const[userData, setUserData] = useState(
    [
      {'user_id': 1, 'username': 'User 1'},
      {'user_id': 2, 'username': 'User 2'},
      {'user_id': 3, 'username': 'User 3'}
    ]
  );

  const[groupData, setGroupData] = useState(
    [
      {'group_id': 1, 'group_name': 'Group 1'},
      {'group_id': 2, 'group_name': 'Group 2'},
      {'group_id': 3, 'group_name': 'Group 3'}
    ]
  );

  const[entitlementData, setEntitlementData] = useState(
    [
      {'user_id': 1, 'group_id': 2, 'permission': 'view'},
      {'user_id': 1, 'group_id': 2, 'permission': 'upload'},
      {'user_id': 2, 'group_id': 3, 'permission': 'view'},
    ]
  );

  const handleComapnyChange = async(e) => {
    e.preventDefault();
    const { name, value } = e.target;
    const token = sessionStorage.getItem('token');
    try {
      const response = await axios.post(`${apiUrl}/get_entitlement_1client`, {client_id: value},
        {
          params: {
            token
          },
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      setUserData(response.data.users)
      setGroupData(response.data.portfolioGroups)
      setEntitlementData(response.data.entitlements);
    } catch(error) {
      console.error('Error update data:', error);
    }

    // update formData
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

  }
    
  const updatePermissions = (userId, groupId) => {
    const permissions = {
      view: false,
      upload: false,
      download: false,
      execute: false,
    }

    const current_permissions = entitlementData.filter(ent => ent.user_id == userId && ent.group_id == groupId)
          .map((row) => (row.permission))

    const new_permissions = current_permissions.reduce((prev, perm) => ({
      ...prev, [perm]: true,
    }), permissions)
    
    // update formData.permissions
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions, // Spread the existing permissions if needed
        ...new_permissions,  // Overwrite with new_permissions
      },
    }));    
  };

  // Handle user changes
  const handleUserChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      user_id: value,
    }));

    updatePermissions(value, formData.group_id)
  }

  const handleGroupChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      group_id: value,
    }));

    updatePermissions(formData.user_id, value)
  }


  // Handle checkbox changes
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      permissions: {
        ...prev.permissions,
        [name]: checked,
      },
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem('token');
    const updates = formData;
    console.log("Form Data:", formData);
    try {
      const response = await axios.post(`${apiUrl}/update_entitlement`, {updates},
        {
          params: {
            token
          },
          headers: {
            'accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
    } catch(error) {
      console.error('Error update data:', error);
    }
    alert("Permissions updated successfully!");
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const response = await axios.get(`${apiUrl}/get_entitlement`, 
          {
            params: {
              token
            }
          }
        );
        console.log("response", response);
        setClientData(response.data.clients);
        setUserData(response.data.users);
        setGroupData(response.data.portfolioGroups);
        setEntitlementData(response.data.entitlements);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (

    <div className="relative bg-gray-900_01 w-full min-h-screen p-5">
    {/* Navbar */}
    <Navbar />

    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <form
        className="bg-white p-6 rounded shadow-md w-[400px]"
        onSubmit={handleSubmit}
      >
        <div className="mb-4">
          <label htmlFor="companyName" className="block text-gray-700 font-bold mb-2">
            Company Name
          </label>
          <select
            id="companyName"
            name="client_id"
            value={formData.client_id}
            onChange={handleComapnyChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="">Select Company</option>
            {clientData.map((row) => (
              <option value={row.client_id}>{row.client_name}</option>
            )
            )}
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="username" className="block text-gray-700 font-bold mb-2">
            Username
          </label>
          <select
            id="username"
            name="user_id"
            value={formData.user_id}
            onChange={handleUserChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="">Select Username</option>
            {userData.map((row) => (
              <option value={row.user_id}>{row.username}</option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label htmlFor="portfolioGroup" className="block text-gray-700 font-bold mb-2">
            Portfolio Group
          </label>
          <select
            id="portfolioGroup"
            name="group_id"
            value={formData.group_id}
            onChange={handleGroupChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="">Select Portfolio Group</option>
            {groupData.map((row) => (
              <option value={row.group_id}>{row.group_name}</option>
            ))}
          </select>
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 font-bold mb-2">
            Permissions:
          </label>
          <div className="flex flex-col">
            <label className="inline-flex items-center mb-2">
              <input
                type="checkbox"
                name="view"
                checked={formData.permissions.view}
                onChange={handleCheckboxChange}
                className="mr-2"
              />
              View
            </label>
            <label className="inline-flex items-center mb-2">
              <input
                type="checkbox"
                name="upload"
                checked={formData.permissions.upload}
                onChange={handleCheckboxChange}
                className="mr-2"
              />
              Upload
            </label>
            <label className="inline-flex items-center mb-2">
              <input
                type="checkbox"
                name="download"
                checked={formData.permissions.download}
                onChange={handleCheckboxChange}
                className="mr-2"
              />
              Download
            </label>
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                name="execute"
                checked={formData.permissions.execute}
                onChange={handleCheckboxChange}
                className="mr-2"
              />
              Execute
            </label>
          </div>
        </div>

        <div>
          <button
            type="submit"
            className="w-full bg-black text-white py-2 rounded hover:bg-gray-800"
          >
            Update
          </button>
        </div>
      </form>
    </div>
    </div>
  );
};

export default UpdateEntitlement;
